import { ensureValidDid } from "@atproto/syntax";
import type { Facet } from "./model.ts";
import { webUrl } from "./uri.ts";

export interface TextPart {
  text: string;
  href?: string;
}

export function richText(text: string, facets: Facet[] = []): TextPart[] {
  const bytes = new TextEncoder().encode(text);
  const decoder = new TextDecoder();
  const parts: TextPart[] = [];
  let position = 0;
  for (
    const facet of [...facets].sort((a, b) =>
      a.index.byteStart - b.index.byteStart
    )
  ) {
    const { byteStart: start, byteEnd: end } = facet.index;
    if (
      !Number.isSafeInteger(start) || !Number.isSafeInteger(end) ||
      start < position || end <= start || end > bytes.length ||
      (bytes[start] & 0xc0) === 0x80 ||
      (end < bytes.length && (bytes[end] & 0xc0) === 0x80)
    ) continue;
    let href: string | undefined;
    for (const feature of facet.features) {
      if (feature.$type === "app.bsky.richtext.facet#link") {
        href = webUrl(feature.uri);
      } else if (feature.$type === "app.bsky.richtext.facet#mention") {
        try {
          ensureValidDid(feature.did);
          href = `https://bsky.app/profile/${encodeURIComponent(feature.did)}`;
        } catch { /* An invalid mention remains plain text. */ }
      } else if (feature.$type === "app.bsky.richtext.facet#tag") {
        href = `https://bsky.app/hashtag/${encodeURIComponent(feature.tag)}`;
      }
      if (href) break;
    }
    if (!href) continue;
    if (start > position) {
      parts.push({ text: decoder.decode(bytes.subarray(position, start)) });
    }
    parts.push({ text: decoder.decode(bytes.subarray(start, end)), href });
    position = end;
  }
  if (position < bytes.length) {
    parts.push({ text: decoder.decode(bytes.subarray(position)) });
  }
  return parts;
}
